import './accessDenied.css'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { FaArrowLeft, FaHome } from 'react-icons/fa'
import { HiShieldExclamation } from 'react-icons/hi'

import logoT4i from '../../assets/img/logo_t4i.png'
import PageWrapper from '../../components/@common/PageWrapper'
import MaterialUI from '../../components/MaterialUI'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import paths from '../../routes/paths'
import { navigateBack } from '../../utils/navigateBack'

export default function AccessDenied() {
  const { formatMessage: trans } = useIntl()
  const history = useHistory()
  const location = useLocation()
  const pageTitle = trans({ id: 'access_denied_title', defaultMessage: 'Access denied' })
  useDocumentTitle(pageTitle)
  const fromLocation = location.state?.from
  const attemptedPath = fromLocation ? `${fromLocation.pathname || ''}${fromLocation.search || ''}` : ''
  const homePath = paths.dashboard
  const handleGoHome = () => {
    history.push(homePath)
  }
  const handleGoBack = () => {
    navigateBack(history, location, { fallback: homePath })
  }
  return (
    <PageWrapper className="access-denied-page" defaultPadding="p-3">
      <div className="access-denied">
        <div className="access-denied__card" role="alert" aria-live="polite">
          <div className="access-denied__logo-wrap">
            <img src={logoT4i} alt="Tech4 Inventory" className="access-denied__logo" />
          </div>
          <div className="access-denied__icon-wrap" aria-hidden="true">
            <HiShieldExclamation className="access-denied__shield-icon" />
          </div>
          <p className="access-denied__code" aria-hidden="true">
            403
          </p>
          <h1 className="access-denied__title">{pageTitle}</h1>
          <p className="access-denied__description">
            {trans({ id: 'access_denied_description', defaultMessage: "You don't have permission to view this page. Ask your company administrator if you need access." })}
          </p>
          {attemptedPath && attemptedPath !== '/' && (
            <p className="access-denied__path-hint">
              {trans({ id: 'access_denied_path_hint', defaultMessage: 'You tried to open "{path}".' }, { path: attemptedPath })}
            </p>
          )}
          <div className="access-denied__actions">
            <MaterialUI.Button.Primary onClick={handleGoHome} className="access-denied__btn">
              <FaHome className="access-denied__btn-icon" />
              {trans({ id: 'page_not_found_go_dashboard', defaultMessage: 'Go to dashboard' })}
            </MaterialUI.Button.Primary>
            <MaterialUI.Button.Light onClick={handleGoBack} className="access-denied__btn access-denied__btn--secondary">
              <FaArrowLeft className="access-denied__btn-icon" />
              {trans({ id: 'page_not_found_go_back', defaultMessage: 'Go back' })}
            </MaterialUI.Button.Light>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}
